const styles = {
        switch: {
            margin: '0 16px'
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center'
        }
}

export default styles